import { Modal } from '../../components/common'
import { SectionCode } from '../../components/section/common'

export default props => (
  <Modal headerTitle={`${props.useCode.title} Code`} modalCloseFocusElem={props.modalCloseFocusElem}>
    <SectionCode {...props} />
  </Modal>
)
